/**
 * API Client for backend communication
 */
import axios from 'axios';

// Use relative URL in production (when served by FastAPI), localhost in development
const API_BASE_URL = process.env.REACT_APP_API_URL || (
  window.location.hostname === 'localhost'
    ? 'http://localhost:8000/api'
    : '/api'
);

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('access_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// ============================================================================
// CANVA AUTH API
// ============================================================================

export const canvaAuthAPI = {
  getStatus: async () => {
    const response = await api.get('/auth/canva/status');
    return response.data;
  },

  revoke: async () => {
    const response = await api.post('/auth/canva/revoke');
    return response.data;
  },
};

// ============================================================================
// JOBS API
// ============================================================================

export const jobsAPI = {
  listJobs: async (skip = 0, limit = 100) => {
    const response = await api.get('/jobs/', { params: { skip, limit } });
    return response.data;
  },

  getJob: async (jobId) => {
    const response = await api.get(`/jobs/${jobId}`);
    return response.data;
  },
};

// ============================================================================
// DASHBOARD API
// ============================================================================

export const dashboardAPI = {
  getData: async () => {
    const response = await api.get('/dashboard/');
    return response.data;
  },
};

// ============================================================================
// AUTOMATION API
// ============================================================================

export const automationAPI = {
  startAutomation: async (data) => {
    const response = await api.post('/automation/start', data);
    return response.data;
  },

  getStatus: async (runId) => {
    const response = await api.get(`/automation/status/${runId}`);
    return response.data;
  },

  getRunProgress: async (runId) => {
    const response = await api.get(`/automation/run/${runId}/progress`);
    return response.data;
  },

  regenerateCaption: async (designId) => {
    const response = await api.post(`/automation/design/${designId}/regenerate-caption`);
    return response.data;
  },
};

// ============================================================================
// HISTORY API
// ============================================================================

export const historyAPI = {
  getRuns: async () => {
    const response = await api.get('/history/runs');
    return response.data;
  },

  getRunDetails: async (runId) => {
    const response = await api.get(`/history/runs/${runId}`);
    return response.data;
  },
};

export default api;